import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// INTERFACES
import { ReadContentTypesInterface } from "../../../interfaces/AdapterCdoOpc.interface";

export default function FormSelectOpcReadContentType({
  inputValue,
  inputOnChange,
  disabledInput,
}: {
  inputValue: ReadContentTypesInterface;
  inputOnChange: (newValue: ReadContentTypesInterface) => void;
  disabledInput: boolean;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Option } = Select;
  const [t] = useTranslation("global");
  const OPTIONS: ReadContentTypesInterface[] = [
    "read_sync_item_message",
    "read_sync_group",
    "get_names",
    "get_status",
    "get_server_list",
    "get_properties",
    "enable_async",
    "read_async_group",
    "read_async_item",
  ];

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="col-md-12 mt-3">
      <div className="generalStyles__flex">
        <div className="generalStyles__inputFlexNameLarge">
          <span className="generalStyles__inputFlexRequired">*</span>
          <span>{t("general.contentType")}</span>
        </div>
        <div className="generalStyles__width100">
          <Select
            className="generalStyles__width100"
            size="small"
            onChange={(e: any) => {
              inputOnChange(e);
            }}
            value={inputValue}
            disabled={disabledInput}
          >
            {OPTIONS.map((item: ReadContentTypesInterface) => (
              <Option key={item} value={item}>
                {item.replace(/_/g, " ")}
              </Option>
            ))}
          </Select>
        </div>
        <div className="generalStyles__infoTooltipIconBlank" />
      </div>
    </div>
  );
}
